import Stats from 'three/examples/jsm/libs/stats.module.js';
import TimeChecker from './timeChecker'
import Params from './parameter'


const INIT_TIME = Date.now();
export default class DebugInfo{
  constructor(){
    this.showElement = document.getElementsByClassName("show-debug-info")[0];
    this.hideElement = document.getElementsByClassName("hide-debug-info")[0];
    this.infoElement = document.getElementsByClassName("debug-info")[0];

    this.programs = document.getElementsByClassName("programs-value")[0];
    this.geometries = document.getElementsByClassName("geometries-value")[0];
    this.textures = document.getElementsByClassName("textures-value")[0];
    this.drawcalls = document.getElementsByClassName("drawcalls-value")[0];
    this.lines = document.getElementsByClassName("lines-value")[0];
    this.points = document.getElementsByClassName("points-value")[0];
    this.triangles = document.getElementsByClassName("triangles-value")[0];

    this.timeinfo = document.getElementsByClassName("time-info-value")[0];
    this.generalInfo = document.getElementsByClassName("general-info-value")[0];
    
    this.showElement.addEventListener('click', this.onShow.bind(this));
    this.hideElement.addEventListener('click', this.onHide.bind(this));

    this.toggle(this.infoElement);

    // put stats.js
    this.stats = new Stats();
    this.stats.dom.style.position = "relative"
    document.getElementsByClassName("stats")[0].appendChild( this.stats.dom );

    // time checker
    this.timeChecker = new TimeChecker(INIT_TIME, true, true, this.timeinfo);

    const paramsText = `modelName: ${Params.modelName}
    defaultMaterial: ${Params.defaultMaterial}
    bEnableDirLight: ${Params.bEnableDirLight}
    bEnableDirLightShadow: ${Params.bEnableDirLightShadow}
    dirLightIntensity: ${Params.dirLightIntensity}
    bEnableAmbientLight: ${Params.bEnableAmbientLight}
    ambientLightIntensity: ${Params.ambientLightIntensity}
    envIntensity: ${Params.envIntensity}
    cubemap: ${Params.cubemapName}
    subDirLightIntensity: ${Params.subDirLightIntensity}
    `
    
    this.generalInfo.innerText = paramsText

    // dev tools
    // Observe a scene or a renderer
    if (typeof __THREE_DEVTOOLS__ !== 'undefined') {
      __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', { detail: this.scene }));
      __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', { detail: this.renderer }));
    }
  }

  onShow(e){
    this.toggle(this.infoElement);
    this.toggle(this.showElement);
  }

  onHide(e){
    this.toggle(this.infoElement);
    this.toggle(this.showElement);
  }

  toggle(target){
    if (target.style.display === "none" || target.style.display === "") {
      target.style.display = "block";
    } else {
      target.style.display = "none";
    }
  }

  checkTime(label){
    this.timeChecker.check(label);
  }

  update(scene, renderer){
    this.stats.update();
    this.programs.innerHTML = renderer.info.programs.length;
    this.geometries.innerHTML = renderer.info.memory.geometries;
    this.textures.innerHTML = renderer.info.memory.textures;
    this.drawcalls.innerHTML = renderer.info.render.calls;
    this.lines.innerHTML = renderer.info.render.lines;
    this.points.innerHTML = renderer.info.render.points;
    this.triangles.innerHTML = renderer.info.render.triangles;
    
    renderer.info.reset();
  }


}
